<template>
  <div
    class="btn"
    type="button"
    :class="isSecondary ? 'btn btn-secondary py-3' : 'btn btn-danger py-3'"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SlButton',
  props: {
    // le style est de type secondary
    isSecondary: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn {
    padding: 1em;
    background-image: none;
    text-shadow: none;
    border: none;
  }
</style>
